/* Boppa · animaciones por scroll, cartel de mail y barra de compra (sin librerías) */
(() => {
  if (window.__bpMotion) return;
  window.__bpMotion = true;

  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) root.classList.add('bp-reduce');

  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

  let scenes = [];
  let views = [];
  let sticky = null;
  let stickyHero = null;
  let stickyStops = [];
  let ticking = false;

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.15 }
        )
      : null;

  /** Envuelve cada palabra para poder animarla sin romper el salto de línea natural. */
  function splitWords(el) {
    if (el.__bpWords) return el.__bpWords;
    const text = el.textContent.replace(/\s+/g, ' ').trim();
    el.textContent = '';
    const parts = text.length ? text.split(' ') : [];
    const words = parts.map((part, index) => {
      const outer = document.createElement('span');
      outer.className = 'bp-w';
      const inner = document.createElement('span');
      inner.className = 'bp-w__in';
      inner.textContent = part;
      outer.appendChild(inner);
      el.appendChild(outer);
      if (index < parts.length - 1) el.appendChild(document.createTextNode(' '));
      return outer;
    });
    el.__bpWords = words;
    return words;
  }

  /** Calcula en qué línea quedó cada palabra (para el retraso escalonado). */
  function indexLines(el) {
    const words = splitWords(el);
    let line = -1;
    let top = null;
    words.forEach((word) => {
      const offset = word.offsetTop;
      if (top === null || Math.abs(offset - top) > 2) {
        line += 1;
        top = offset;
      }
      word.style.setProperty('--l', line);
    });
    el.classList.add('bp-ready');
  }

  /** Letras duplicadas para el efecto de giro en los botones. */
  function splitFlip(el) {
    if (el.__bpFlip) return;
    el.__bpFlip = true;
    const text = el.textContent.replace(/\s+/g, ' ').trim();
    el.textContent = '';
    const label = document.createElement('span');
    label.className = 'bp-sr';
    label.textContent = text;
    el.appendChild(label);
    Array.from(text).forEach((char, index) => {
      const letter = document.createElement('span');
      const value = char === ' ' ? ' ' : char;
      letter.className = 'bp-f';
      letter.setAttribute('aria-hidden', 'true');
      letter.style.setProperty('--i', index);
      letter.dataset.c = value;
      letter.textContent = value;
      el.appendChild(letter);
    });
  }

  function setStep(scene, steps, index) {
    scene.__bpIndex = index;
    steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
    const active = steps[index];
    const cam = scene.querySelector('[data-bp-cam]');
    if (cam && active) {
      cam.style.setProperty('--fx', active.dataset.fx || 50);
      cam.style.setProperty('--fy', active.dataset.fy || 50);
      cam.style.setProperty('--z', active.dataset.z || 1);
    }
    const count = scene.querySelector('[data-bp-count]');
    if (count) count.textContent = String(index + 1).padStart(2, '0');
  }

  function update() {
    ticking = false;
    const vh = window.innerHeight;

    scenes.forEach((scene) => {
      const rect = scene.getBoundingClientRect();
      if (rect.bottom < -vh || rect.top > vh * 2) return;

      const pin = scene.__bpPin || (scene.__bpPin = scene.querySelector('[data-bp-pin]'));
      const pinHeight = pin ? pin.offsetHeight : vh;
      const offset = pin ? vh - pinHeight : 0;
      const total = Math.max(1, rect.height - pinHeight);
      const progress = clamp((offset - rect.top) / total);
      scene.style.setProperty('--p', progress.toFixed(4));

      const steps = scene.__bpSteps || (scene.__bpSteps = Array.from(scene.querySelectorAll('[data-bp-step]')));
      if (steps.length) {
        const index = Math.min(steps.length - 1, Math.floor(progress * steps.length));
        if (scene.__bpIndex !== index) setStep(scene, steps, index);
      }
    });

    views.forEach((view) => {
      const rect = view.getBoundingClientRect();
      if (rect.bottom < -vh || rect.top > vh * 2) return;
      view.style.setProperty('--in', clamp((vh - rect.top) / vh).toFixed(4));
      view.style.setProperty('--out', clamp(-rect.top / Math.max(1, rect.height)).toFixed(4));
    });

    if (sticky && stickyHero) {
      let on = stickyHero.getBoundingClientRect().bottom < 90;
      stickyStops.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < vh - 80 && rect.bottom > 0) on = false;
      });
      sticky.classList.toggle('is-on', on);
    }
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function collect() {
    scenes = Array.from(document.querySelectorAll('[data-bp-scene]'));
    views = Array.from(document.querySelectorAll('[data-bp-view]'));
    scenes.forEach((scene) => {
      scene.__bpPin = null;
      scene.__bpSteps = null;
      scene.__bpIndex = undefined;
    });

    sticky = document.querySelector('[data-bp-sticky]');
    stickyHero = document.querySelector('.bp-hero');
    stickyStops = Array.from(document.querySelectorAll('.bp-buy, footer'));

    document.querySelectorAll('[data-bp-lines]').forEach(indexLines);
    document.querySelectorAll('[data-bp-flip]').forEach(splitFlip);

    document.querySelectorAll('[data-bp-lines], [data-bp-reveal]').forEach((el) => {
      if (reduce || !observer) {
        el.classList.add('is-in');
      } else if (!el.classList.contains('is-in')) {
        observer.observe(el);
      }
    });

    if (reduce) {
      scenes.forEach((scene) => {
        scene.querySelectorAll('[data-bp-step]').forEach((step) => step.classList.add('is-active'));
      });
    }

    update();
  }

  /* ---------- Cartel de mail con cupón ---------- */

  const POPUP_KEY = 'bpPopup';
  const DAY = 864e5;

  function readPopupState() {
    try {
      return JSON.parse(window.localStorage.getItem(POPUP_KEY) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function writePopupState(state) {
    try {
      window.localStorage.setItem(POPUP_KEY, JSON.stringify(state));
    } catch (error) {
      /* almacenamiento bloqueado: el cartel puede volver a aparecer */
    }
  }

  function initPopup() {
    const popup = document.querySelector('[data-bp-popup]');
    if (!popup || popup.__bp) return;
    popup.__bp = true;

    const code = popup.dataset.code || '';
    const posted =
      Boolean(popup.querySelector('[data-bp-popup-flag="success"]')) || /[?&]customer_posted=true/.test(window.location.search);
    const failed = Boolean(popup.querySelector('[data-bp-popup-flag="error"]'));
    let lastFocus = null;
    let closeTimer = null;

    const open = (state) => {
      window.clearTimeout(closeTimer);
      if (state) popup.dataset.state = state;
      lastFocus = document.activeElement;
      popup.hidden = false;
      root.classList.add('bp-popup-open');
      // Fuerza un reflow para que la transición corra aunque la pestaña esté en segundo plano
      void popup.offsetWidth;
      popup.classList.add('is-open');
      const target = popup.querySelector(popup.dataset.state === 'success' ? '[data-bp-copy]' : 'input[type="email"]');
      if (target) window.setTimeout(() => target.focus({ preventScroll: true }), 450);
    };

    const close = () => {
      popup.classList.remove('is-open');
      root.classList.remove('bp-popup-open');
      closeTimer = window.setTimeout(() => {
        popup.hidden = true;
      }, 450);
      const state = readPopupState();
      if (!state.subscribed) writePopupState({ dismissed: Date.now() });
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    };

    popup.addEventListener('click', (event) => {
      if (event.target.closest('[data-bp-popup-close]') || event.target.classList.contains('bp-popup__backdrop')) close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-bp-popup-open]');
      if (!trigger) return;
      event.preventDefault();
      open(readPopupState().subscribed ? 'success' : 'form');
    });

    const copy = popup.querySelector('[data-bp-copy]');
    if (copy) {
      copy.addEventListener('click', () => {
        const done = () => {
          const original = copy.dataset.label || copy.textContent;
          copy.dataset.label = original;
          copy.textContent = copy.dataset.done || 'Copiado';
          window.setTimeout(() => {
            copy.textContent = original;
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          done();
        }
      });
    }

    if (window.Shopify && window.Shopify.designMode) return;

    if (posted && !failed) {
      writePopupState({ subscribed: Date.now() });
      // Deja el cupón aplicado para el checkout de esta visita
      if (code) window.fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(() => {});
      open('success');
      return;
    }

    if (failed) {
      open('form');
      return;
    }

    const state = readPopupState();
    if (state.subscribed) return;
    if (state.dismissed && Date.now() - state.dismissed < Number(popup.dataset.days || 7) * DAY) return;

    const splashEnd = window.__bpSplashEnd || 0;
    const wait = splashEnd ? Math.max(400, splashEnd - window.performance.now() + 250) : Number(popup.dataset.delay || 3) * 1000;
    window.setTimeout(() => {
      if (!popup.classList.contains('is-open')) open('form');
    }, wait);
  }

  function init() {
    collect();
    initPopup();

    // capture: también escucha el scroll de contenedores internos (no burbujea)
    document.addEventListener('scroll', requestUpdate, { passive: true, capture: true });

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        document.querySelectorAll('[data-bp-lines]').forEach(indexLines);
        requestUpdate();
      }, 150);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        document.querySelectorAll('[data-bp-lines]').forEach(indexLines);
        requestUpdate();
      });
    }

    document.addEventListener('shopify:section:load', () => {
      collect();
      initPopup();
    });
    document.addEventListener('shopify:section:reorder', collect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
